import { render, staticRenderFns } from "./Invoice_id.vue?vue&type=template&id=2958f37e"
import script from "./Invoice_id.vue?vue&type=script&lang=js"
export * from "./Invoice_id.vue?vue&type=script&lang=js"
import style0 from "./Invoice_id.vue?vue&type=style&index=0&id=2958f37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports